import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import DeletePhotosDocument from "src/api/graphql/__generated__/documents/DeletePhotosDocument";
import evictPhotos from "src/api/graphql/evictPhotos";

const useDeletePhotos = () => {
	const apolloClient = useApolloClient();
	const handleDeletePhotos = useCallback(
		async (photoIds: string[]) => {
			if (photoIds.length === 0) return;
			await apolloClient.mutate({
				mutation: DeletePhotosDocument,
				variables: {
					input: {
						photoIds,
					},
				},
			});

			evictPhotos(apolloClient.cache, photoIds, {
				delay: 300,
			});
		},
		[apolloClient],
	);
	return handleDeletePhotos;
};
export default useDeletePhotos;
